export default "__VITE_ASSET__fF3t3hFV__"